import {
  RESET_ALL_USER_LISTS,
  MARK_USER_LIST_AS_RESETED,
  RESET_SINGLE_USER_LIST
} from '../../constants/actions';

const initialState = {
  resetMatches: false,
  resetSearch: false,
  resetQuickMatch: false,
  resetMyLikes: false,
  resetMutual: false,
  resetWhoIsOnlineRecent: false,
  resetWhoIsOnlineWeek: false,
  resetBrowse: false,
  resetSentMessages: false
};

export default function reducer (state = initialState, action = {}) {
  const currentState = {...state};
  switch (action.type) {
    case RESET_ALL_USER_LISTS:
      for (let key in currentState) {
        if (key !== 'resetMyLikes') {
          currentState[key] = true;
        }
      }
      return currentState;
    case MARK_USER_LIST_AS_RESETED:
      // console.log('MARK_USER_LIST_AS_RESETED', action);
      const list = action.userList;
      currentState[list] = false;
      return currentState;
    case RESET_SINGLE_USER_LIST:
      currentState[action.userList] = true;
      return currentState;
    default:
      return state;
  }
}
